
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/character/detail",
      function () {
        return require("private-next-pages/m/character/detail.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/character/detail"])
      });
    }
  